import React from 'react';

import { Box, BoxProps, Button, Typography, TypographyProps } from '@mui/material';

interface IRetry extends Omit<BoxProps, 'ref'>, Pick<TypographyProps, 'variant'> {
  retry: () => void;
}

export const Retry: React.FC<IRetry> = (props) => {
  const { variant = 'h4', sx, retry, children, ...others } = props;
  return (
    <Box
      sx={[{
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
      },
      ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...others}
    >
      <Typography variant={variant}>
        Sorry, something went wrong.
      </Typography>
      <Typography variant={variant}>
        We couldn’t load {children}.
      </Typography>
      <Button onClick={retry} sx={{ mt: '34px' }}>
        Try again
      </Button>
    </Box>
  );
}
